import MainLoader from './MainLoader';

export default MainLoader;
